<template>
    <div i='footer_wrap'>
        <div class="footer"><span class="pointer" @click="goto()">粤ICP备18043405号</span>&nbsp;&nbsp;Copyright © 2006-2020 大艺博官网</div>
    </div>
</template>
<style rel='stylesheet/scss' lang='scss' scoped>
    @import '../assets/sass/common/tool';

    [i="footer_wrap"]{
        background-color: #f2f2f2;
        // cursor: pointer;
        .footer{
            height: 60px;
            line-height: 60px;
            color: #999;
            font-size: 14px;
            text-align: center;
            background-color: #1b1b1b;
        }
    }
</style>
<script>
    export default{
        data(){
            return {

            }
        },
        props: [],
        methods:{
            goto() {
                window.open('https://beian.miit.gov.cn/');
            }
        },
        watch: {

        },
        components:{

        },
        filters: {

        },
        mounted(){

        },
        destroyed(){

        }
    }
</script>


// WEBPACK FOOTER //
// Footer.vue?1463f842